const isOdd = int => Math.abs(int % 2) == 1
export default isOdd
